import { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Link2, Copy, RefreshCw } from "lucide-react";

const URL = `${process.env.REACT_APP_BACKEND_URL}/api/integrations/completions`;

const instruction = (key) => `When a learner completes a course and their certificate is issued, send a POST request to ${URL}
Header: X-API-Key: ${key}
JSON body: {"candidate_email": "<learner email>", "candidate_name": "<learner full name>", "course_title": "<course title exactly as in the shop>", "completed_on": "<YYYY-MM-DD>", "certificate_number": "<certificate number>"}
Send it in the background after the certificate is issued and log any non-200 response; do not block the learner.`;

export const CompletionsLink = () => {
  const [key, setKey] = useState("");
  useEffect(() => { api.get("/integrations/completions-key").then(({ data }) => setKey(data.key)).catch(() => {}); }, []);
  const copy = (t) => navigator.clipboard.writeText(t).then(() => toast.success("Copied"));
  const regen = async () => {
    if (!window.confirm("Make a new key? The other system will stop updating until you paste the new instruction there.")) return;
    const { data } = await api.post("/integrations/completions-key/regenerate");
    setKey(data.key); toast.success("New key created");
  };
  return (
    <Card className="p-5 space-y-3" data-testid="completions-link-card">
      <h3 className="font-heading font-semibold flex items-center gap-2"><Link2 className="h-4 w-4 text-primary" />Connect your e-learning system</h3>
      <p className="text-sm text-muted-foreground">Paste this instruction into your other Emergent project. When it issues a certificate, the learner's booking here is marked completed with the certificate number and date. If there's no booking, it's added to the learner's previous training.</p>
      <pre className="text-xs bg-muted rounded-md p-3 whitespace-pre-wrap break-all" data-testid="completions-instruction">{key ? instruction(key) : "Loading…"}</pre>
      <div className="flex gap-2 flex-wrap">
        <Button size="sm" onClick={() => copy(instruction(key))} disabled={!key} data-testid="completions-copy-button"><Copy className="h-4 w-4 mr-1.5" />Copy instruction</Button>
        <Button size="sm" variant="outline" onClick={regen} data-testid="completions-regenerate-button"><RefreshCw className="h-4 w-4 mr-1.5" />New key</Button>
      </div>
    </Card>
  );
};
